import React, { Component } from 'react'
import { Link } from 'react-router-dom'


// styles
import './index.scss'

// Constatns
import { PROJECT, CLIENTS } from './constants'
import { ICONS } from '../../constants'

// Images
import hub from '../../images/contract-vehicles/hubzone.jpg'
import sba from '../../images/contract-vehicles/sba.png'
import cmas from '../../images/contract-vehicles/cmas.png'
import gsa from '../../images/contract-vehicles/gsa.jpg'

// Components
import Media from '../../components/Media'
import Clients from './Clients'
import ESlider from '../../components/ESlider'

class Home extends Component {

  constructor(props) {
    super(props)
    this.state = {
      showVideo: false,
    }
  }

  componentDidMount = () => {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
      this.setState({ showVideo: true })
    } else {
      this.setState({ showVideo: false })
    }
  }

  render = () => {

    const { showVideo } = this.state

    return (
      <div className="home-section">

        <div className="intro-video">
          <div className="inner">

            <video ref="video" src="https://eidim-media2.s3-us-west-1.amazonaws.com/video/showreel.mp4" muted autoPlay loop></video>

          </div>

          <div className="video-content flex vh-center">
            <h1>Everything is done in the maker</h1>
            <p>Spirituality & Competency Combined</p>
            <div className="flex" style={{ marginTop: '5rem' }}>
              <button type="button" className="video-btn" onClick={() => this.props.history.push('/contact-us')}>Let us know what you think</button>
              {
                showVideo && <button type="button" className="play-btn" onClick={() => this.refs.video.play()}>Play Video</button>
              }
            </div>
          </div>

        </div>

        <div className="f-w">
          <div className="flex relative xlg-col-flex">

            <div className="width-5">
              <Media
                className="height-5 bg-sol-1"
                link="/solutions"
                head="End-to-End AV Solutions"
                content="EIDIM is recognized by the accomplishments of state-of-the-art audiovisual system solutions for different sectors including but not limited to
                Federal-State-Local Government, Education, and House of Worships."
              />
            </div>

            <div className="width-5">
              <div className="content vh-center">
                <div className="get-a-quote flex">
                  <div className="inner c-padd">
                    <img src="https://eidim-media2.s3-us-west-1.amazonaws.com/images/gallery/get-quote-icon.png" alt="Quote" />
                    <a href="/company/get-a-quote">
                      <h4>Get A Quote</h4>
                    </a>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>


        <div className="f-w">
          <div className="flex relative xlg-col-flex">
            <div className="width-4">
              <Media
                className="height-5 bg-corp-3"
                link="/services"
                head="Services"
                content="EIDIM offers customized and up-to-date Audio-Visual system integration. We can provide high-quality to reasonable and affordable price to exceed customer’s expectation. EIDIM has the expertise and commitment to achieve your AV needs."
              />

            </div>

            <div className="width-6">
              <Media
                className="height-5 bg-sol-2"
                link="/market"
                head="Market"
                content="EIDIM offers a comprehensive audio visual service making us the AV partner of choice for many organisations. We can lead and manage large and complex audio visual projects, but also tailor effective solutions for smaller-scale requirements."
              />
            </div>
          </div>
        </div>

        <div className="f-w">
          <section className="clients-parent">
            <h2>Brands</h2>
            <ESlider
              settings={CLIENTS.settings}
              component={
                CLIENTS.logo.map((item, i) => {
                  return (
                    <Clients {...item} key={`client${i}`} />
                  )
                })
              }
            />
          </section>
        </div>

        <div className="f-w">
          <section className="miscellaneous">
            <div className="flex relative xlg-col-flex">
              <div className="width-6">

                <div className="project-gallery">

                  <Link to="/company/gallery">
                    <div className="content">
                      <h2>Project Galleries</h2>
                      {/* <p style={{marginTop: '2rem'}}>askldjflaks kasjdlf jlsf slkfjlsdkfj</p> */}
                    </div>
                  </Link>

                  <ESlider
                    settings={PROJECT.settings}
                    component={
                      PROJECT.gallery.map((item, i) => {
                        return (
                          <div className={`inner ${item} height-8`} key={item}></div>
                        )
                      })
                    }
                  />

                </div>

              </div>

              <div className="width-4">

                <Media
                  className="height-4 bg-whats-new"
                  link="/company/newsletter"
                  head="Newsletters"
                />


                <Media
                  className="height-4 bg-corp-2"
                  link="/company/case-study"
                  head="Case Study"
                />

              </div>

            </div>
          </section>
        </div>

        <div className="contract">
          <div className="container">
            <h2>Contract Vehicles</h2>
            <div className="inner flex lg-flex-wrap">

              <div className="logo c-padd">
                <a href="https://www.dgsapps.dgs.ca.gov/PD/CMASSearch/Default.aspx" target="_blank" rel="noopener noreferrer">
                  <img src={cmas} alt="CMAS" />
                </a>
              </div>

              <div className="logo c-padd">
                <a href="https://www.gsaadvantage.gov/advantage/contractor/contractor_detail.do?mapName=/catalog/product_detail&amp;oid=684759945&amp;contractNumber=GS-03F-105AA" target="_blank" rel="noopener noreferrer">
                  <img src={gsa} alt="GSA" />
                </a>
              </div>

              <div className="logo c-padd">
                <a href="https://www.avixa.org/training-certification/certification/apex-company-program" target="_blank" rel="noopener noreferrer">
                  <img src={sba} alt="SBA" />
                </a>
              </div>

              <div className="logo c-padd">
                <a href="https://www.avixa.org/training-certification/certification/apex-company-program" target="_blank" rel="noopener noreferrer">
                  <img src={hub} alt="Hub Zone" />
                </a>
              </div>

            </div>
          </div>
        </div>


      </div >
    )
  }
}

export default Home